export const nameDisplayHelper = (fullName: string) => {
    const nameArray = fullName.split(" ");
    let newNameFormat: string[] = [];
    nameArray.forEach((singleName: string) => {
        const capitalizedName = singleName.charAt(0) + singleName.slice(1).toLowerCase();
        newNameFormat.push(capitalizedName);
    });
    return newNameFormat.join(' ');
}